import {Rental} from '../../../../common/types/rental'
import {parseISO} from '../../../../common/utils/dateUtils'

export interface RentalTimeOfDayData {
  label: string
  count: number
  percentage: number
}

export const generateRentalTimeOfDayData = (rentals: Rental[]): RentalTimeOfDayData[] => {
  const hourCounts: Record<number, number> = {}
  const total = rentals.length

  rentals.forEach((rental) => {
    const rentStart = rental.rentStart
    if (rentStart) {
      const date = parseISO(rentStart)
      const hour = date.getHours()
      hourCounts[hour] = (hourCounts[hour] ?? 0) + 1
    }
  })

  return Array.from({length: 24}, (_, hour) => {
    const count = hourCounts[hour] ?? 0
    return {
      label: hour.toString(),
      count,
      percentage: total > 0 ? count / total : 0,
    }
  })
}
